import { ErrorState } from "@shared/common/components/State/ErrorState";
import { LoadingState } from "@shared/common/components/State/LoadingState";
import Markdown from "react-markdown";
import { ToggleableDialog, ToggleableDialogProps } from "./ToggleableDialog";
import { useQuery } from "@tanstack/react-query";
import { useOpstelClient } from "@opstel/contexts/opstelClient/useOpstelClient";

interface ReleaseNotesDialogProps extends Readonly<ToggleableDialogProps> {
  readonly hasBeenOpened: boolean;
}

export function ReleaseNotesDialog({
  dialogRef,
  hasBeenOpened,
}: ReleaseNotesDialogProps): React.JSX.Element {
  const { opstelClient } = useOpstelClient();

  const query = useQuery({
    enabled: hasBeenOpened,
    queryKey: ["getReleaseNotes"],
    queryFn: async () => await opstelClient.getReleaseNotes(),
  });

  if (query.isError) {
    console.error("Error when retrieving release notes: " + query.error.message);
  }

  return (
    <ToggleableDialog dialogRef={dialogRef} size="m" heading="Release notes">
      {query.isLoading && (
        <LoadingState message="Release notes worden opgehaald..." fullPage={false} />
      )}
      {(query.isError || (!query.isLoading && !query.data)) && <ErrorState />}
      {query.data && <Markdown>{query.data}</Markdown>}
    </ToggleableDialog>
  );
}
